<template>
    <div class="energyItem-container">
        <div :class="['item-wrapper', cellIndex > 0 ? 'borderTop' : '']">
            <div class="item-left">
                <div class="item-title">{{ title }}</div>
                <div class="item-date">{{ date | dateFormat('Lllmm') }}</div>
            </div>
            <div class="item-right">{{ point > 0 ? `+${point}` : point }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'energyItem',
    props: {
        cellIndex: Number,
        title: String,
        date: Number,
        point: Number
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
@import '../../../../common/style/borderLine.scss';
.energyItem-container {
    width: 100%;
    height: 70px;
    background: #ffffff;
    @include border-line-style(#f5f8fa);
    .item-wrapper {
        display: flex;
        display: -webkit-flex;
        padding: 18px;
        .item-left {
            flex: 1;
            .item-title {
                font-size: 15px;
                // font-family: fzlt;
                font-weight: normal;
                color: rgba(0, 42, 60, 1);
                line-height: 17px;
            }
            .item-date {
                margin-top: 8px;
                font-size: 12px;
                // font-family: fzlt;
                font-weight: normal;
                color: rgba(159, 170, 181, 1);
                line-height: 12px;
            }
        }
        .item-right {
            flex: 1;
            text-align: right;
            font-size: 18px;
            // font-family: fzlt;
            font-weight: normal;
            color: rgba(0, 42, 60, 1);
            line-height: 34px;
        }
    }
}
</style>
